import { chartColors } from '@UILibrary/utils'

export const buildLineChartDataProp = ({ averageValues, cohortValues, enrolledClients }, benchmark) => {
  const cohortColors = [
    chartColors['salem-60'],
    chartColors['mango-orange-30'],
    chartColors['rhythm-40'],
    chartColors['golden-rod-500'],
    chartColors['apple-green-40'],
    chartColors['salmon-pink-50'],
  ]

  const datasets = cohortValues.map((cohort) => ({
    backgroundColor: cohortColors[(cohort.number - 1) % cohortColors.length] || cohortColors[0],
    borderColor: cohortColors[(cohort.number - 1) % cohortColors.length] || cohortColors[0],
    data: cohort.values.map((item) => item.value),
    label: `Cohort ${cohort.number}`,
    type: 'line',
    yAxisID: 'y',
  }))

  datasets.push({
    backgroundColor: chartColors['true-blue-10'],
    borderColor: chartColors['true-blue-10'],
    data: averageValues.map((item) => item.value),
    label: 'Average',
    type: 'line',
  })

  datasets.push({
    backgroundColor: chartColors['gray-90'],
    borderColor: chartColors['gray-90'],
    borderRadius: 7,
    data: enrolledClients.map((item) => item.value),
    label: 'Enrolled Members',
    type: 'bar',
    yAxisID: 'y1',
    hidden: true,
  })

  return datasets
}
